import { DietCount, MenuConcept } from './types'

export const getAvailableDaysStr = (menu: MenuConcept) => {
  if (menu.availableDays.length === 0) {
    return 'N/A'
  }

  const dayNames = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA']
  const dayAbbreviations = menu.availableDays.map((day) => dayNames[day])

  return dayAbbreviations.join(', ')
}

export const getDietaryCountsArray = (menu: MenuConcept): DietCount[] => {
  return Object.entries(menu.dietaryCounts).map(([dietary, count]) => {
    return { tag: dietary, count }
  })
}
